module.exports = __webpack_public_path__ + "static/media/cdi-icon.4cece367.png";